import { connectColors } from '@/theme/colors';

export const VerticalSeparator = () => (
  <div style={{ width: '40px', display: 'flex', justifyContent: 'center' }}>
    <div
      style={{
        width: '1px',
        height: '24px',
        backgroundColor: connectColors.transparent.slate[700],
      }}
    />
  </div>
);
